import Sortable from 'sortablejs'

export function initializeSortables(content: HTMLElement): void {
  const sortables = content.querySelectorAll('.sortable')

  for (let i = 0; i < sortables.length; i++) {
    const sortable = sortables[i] as HTMLElement
    const sortableInstance = new Sortable(sortable, {
      animation: 150,
      ghostClass: 'blue-background-class',
      onEnd(evt) {
        // Use `any` for `this`
        ;(this as any).option('disabled', true) // Disable sorting during request
      },
    })

    sortable.addEventListener('htmx:afterSwap', function () {
      sortableInstance.option('disabled', false) // Re-enable sorting
    })
  }
}
